import { ToggleListComposite } from "@/appComponents/Blocks/Composites/ToggleListComposite/ToggleListComposite";
import { EditGrouping } from "./EditGrouping";
import { useGroupingController } from "./useGroupingController";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import { appstr } from "@coreapp/utils/appstr";
import { TOAST_STATUS, useToast } from "@/providers/ToastProvider";
import { createBoldToastMessage } from "@/appComponents/Blocks/Cards/ToastContainer/utils";
import { BigInfoIcon, Flex, Text } from "@theorgchartdev/storybook";

export const Grouping = () => {
  const {
    groups,
    onCreateGroup,
    onEditGroup,
    handleSave,
    ToggleGroup,
    toggleGroupStyle,
    updateConditonalRule,
    onDeleteGroup,
    setGroupField,
    setEmployeeBoxStyle,
    setCustomGroupStyle,
    setManagerGroupStyle,
    setManagerCustomGroupStyle,
    setManagerChildrenBoxStyle,
    getCustomGroupStyles,
    getEmployeeBoxStyles,
    editState,
    nameErrorShown,
    nameErrorMessage,
    fieldErrorShown,
    fieldErrorMessage,
    rulePairError,
    groupIsActive,
    getIsNewGroupMode,
    handleGoBack
  } = useGroupingController();
  const { canAccessGrouping } = usePermissionCheck();
  const { addToast } = useToast();

  const HandleUpdate = (mode, data) => {
    switch (mode) {
      case "fGroupingField":
      case "fGroupingThreshold":
      case "name":
      case "conditionalEnabled":
      case "fApplyToManagers":
        setGroupField(mode, data);
        break;
      case "toggleGroupStyle":
        toggleGroupStyle(data);
        break;
      case "setCustomGroupStyle":
        setCustomGroupStyle(data);
        break;
      case "fChildrenBoxStyle":
        setEmployeeBoxStyle(data);
        break;
      case "toggleManagerGroupStyle":
        setManagerGroupStyle(data);
        break;
      case "setManagerCustomGroupStyle":
        setManagerCustomGroupStyle(data);
        break;
      case "fManagerChildrenBoxStyle":
        setManagerChildrenBoxStyle(data);
        break;
      case "conditionalRule":
        updateConditonalRule(data);
        break;
      case "save":
        handleSave();
        break;
      default:
        break;
    }
  };

  return (
    <>
      {editState.showModal && editState.editingGroup ? (
        <EditGrouping
          group={editState.editingGroup}
          HandleUpdate={HandleUpdate}
          onBackBtnClick={handleGoBack}
          nameErrorShown={nameErrorShown}
          nameErrorMessage={nameErrorMessage}
          fieldErrorShown={fieldErrorShown}
          fieldErrorMessage={fieldErrorMessage}
          rulePairError={rulePairError}
          customGroupStyles={getCustomGroupStyles()}
          employeeBoxStyles={getEmployeeBoxStyles()}
          managerCustomGroupStyles={getCustomGroupStyles()}
          managerEmployeeBoxStyles={getEmployeeBoxStyles()}
          getIsNewGroupMode={getIsNewGroupMode}
          onDelete={async () => {
            const groupName = editState.editingGroup?.name ?? "";
            await onDeleteGroup(editState.editingGroup?.id);
            handleGoBack(true);
            addToast({
              ...createBoldToastMessage("Entity deleted", { entity: groupName }),
              status: TOAST_STATUS.SUCCESS
            });
          }}
        />
      ) : (
        <>
          <Flex direction="column" padding="16px">
            <Text size="small">{appstr("Grouping tab description")}</Text>
          </Flex>
          <ToggleListComposite
            items={groups}
            createStr={appstr("Create group")}
            onCreate={onCreateGroup}
            onToggle={ToggleGroup}
            onEdit={onEditGroup}
            onDelete={onDeleteGroup}
            onSave={() => {}}
            isChecked={id => groupIsActive(id)}
            dataTestId={"rsb-grouping-list"}
            canEdit={canAccessGrouping}
            emptyState={
              <BigInfoIcon
                color="brand"
                name="grouping"
                message={appstr("No groups created yet")}
              />
            }
          />
        </>
      )}
    </>
  );
};
